import axios from 'axios';

export default {
    install: function (Vue) {
        Vue.prototype.getSymptomTypes = (callback) => getSymptomTypes(callback);//症状类型
        Vue.prototype.getPositions = (callback) => getPositions(callback);//部位
        Vue.prototype.getSexes = (callback) => getSexes(callback);//性别
        Vue.prototype.getAgeGroups = (callback) => getAgeGroups(callback);//年龄段
        Vue.prototype.getDiseaseTypes = (callback) => getDiseaseTypes(callback);//疾病类型
        Vue.prototype.getDiseaseGroups = (callback) => getDiseaseGroups(callback);//疾病分组
        Vue.prototype.getDrugTypes = (callback) => getDrugTypes(callback);//药品类型
        Vue.prototype.getDrugForms = (callback) => getDrugForms(callback);//药品剂型
        Vue.prototype.getInvoiceTypes = (callback) => getInvoiceTypes(callback);//药品发票类型
        Vue.prototype.getProfessionTitles = (params, callback) => getProfessionTitles(params, callback);//职称
        Vue.prototype.getStandardDepartmentTree = (callback) => getStandardDepartmentTree(callback);//标准科室树
        Vue.prototype.getSyndromeTypes = (callback) => getSyndromeTypes(callback);//证候类型
        Vue.prototype.getTreatmentTypes = (callback) => getTreatmentTypes(callback);//治法类型
        Vue.prototype.getHospitalTypes = (type, callback) => getHospitalTypes(type, callback);//医疗机构类型
        Vue.prototype.getDepartmentTypes = (callback) => getDepartmentTypes(callback);//科室类型
        Vue.prototype.getRegisterStatues = (callback) => getRegisterStatues(callback);//审批状态
        Vue.prototype.getDepartmentTree = (params, callback) => getDepartmentTree(params, callback);//机构科室树
        Vue.prototype.getEducations = (callback) => getEducations(callback);//学历
        Vue.prototype.getMarriages = (callback) => getMarriages(callback);//婚姻状况
        Vue.prototype.getSuppliers = (keyword, length, callback) => getSuppliers(keyword, length, callback); //药品供应商
        Vue.prototype.getStockTypes = (callback) => getStockTypes(callback);//入库分类
        Vue.prototype.getStockInTypes = (callback) => getStockInTypes(callback);//入库分类
        Vue.prototype.getStockOutTypes = (callback) => getStockOutTypes(callback);//出库分类
	    Vue.prototype.getDeliveryModels = (callback) => getDeliveryModels(callback);//取货方式
	    Vue.prototype.getExpressUnits = (callback) => getExpressUnits(callback);//快递公司
        Vue.prototype.getPaymentMethods = (organId, scope, params, callback) => getPaymentMethods(organId, scope, params, callback);//支付方式
        Vue.prototype.getProvinces = (params, callback) => getProvinces(params, callback);//加载省级辖区
        Vue.prototype.getFrequencies = (callback) => getFrequencies(callback);//用药频次分类
        Vue.prototype.getDoctors = (params, callback) => getDoctors(params, callback);// 医生树
        Vue.prototype.getOrganConfig=(organId, code, callback) => getOrganConfig(organId, code, callback);//获取机构参数
        Vue.prototype.getSystemConfig = (code, callback) => getSystemConfig(code, callback);    //获取系统参数
        Vue.prototype.getApplyOrganizations = (callback) => getApplyOrganizations(callback);    //获取申请机构列表
    }
}

function getDoctors(params, callback){
    axios.get('/api/clinic/doctor/trees', params).then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getFrequencies(callback){
    let res =[{code:'qd', desc:'每日一次', quantity:1},{code:'st', desc:'每日两次', quantity:2},
        {code:'tid', desc:'每日三次', quantity:3},{code:'qid', desc:'每日四次', quantity:4},
        {code:'qn', desc:'每晚一次', quantity:1},{code:'q2n', desc:'每2小时一次', quantity:12},
        {code:'q12h', desc:'每12小时一次', quantity:2},{code:'q4h', desc:'每4小时一次', quantity:6},
        {code:'q6h', desc:'每6小时一次', quantity:4},{code:'q8h', desc:'每8小时一次', quantity:3},
        {code:'qod', desc:'每隔一天', quantity:0.5},{code:'qh', desc:'每小时', quantity:24},
        {code:'q30m', desc:'每30分钟一次', quantity:48}];

    (callback & callback(res));

    /*axios.get('/api/dmz/dict/frequencies').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });*/
}

function getPaymentMethods(organId, scope, params, callback){
    axios.get('/api/dmz/dict/'+organId+'/'+ scope +'/paymethods', params).then(function (res) {
        if (res.msg.flag == 0 && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getMarriages(callback){
    let res =[{name:'UNMARRIED',value:'未婚'},{name:'MARRIED',value:'已婚'},{name:'WIDOWED',value:'丧偶'},
        {name:'DIVORCE',value:'离婚'}, {name:'NOT_EXPLAINED',value:'未说明'}];

    (callback & callback(res));
    /*axios.get('/api/dmz/dict/marriages').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });*/
}

function getEducations(callback){
    axios.get('/api/dmz/dict/educations').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getProfessionTitles(params, callback){
    axios.get('/api/dmz/dict/profession/titles', params).then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getHospitalTypes(type, callback){
    axios.get('/api/dmz/dict/hospital/'+type+'/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getRegisterStatues(callback) {
    axios.get('/api/dmz/dict/register/statues').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}
//加载省级
function getProvinces(params, callback){
    axios.get('/api/dmz/district/childrens', params).then(function (res) {
        if (res.msg.flag == 0) {
            if(null != res.biz && undefined != res.biz && null != res.biz && !res.biz.empty){
                callback & callback(res.biz);
            }
        }
    }, function (res) {
    });
}


function getDepartmentTree(params, callback){
    axios.get('/api/clinic/department/trees', params).then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getStandardDepartmentTree(callback){
    //加载标准科室
    axios.get('/api/dmz/standard/department/tree').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getDepartmentTypes(callback){
    axios.get('/api/dmz/dict/department/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getTreatmentTypes(callback){
    axios.get('/api/dmz/dict/treatment/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getSyndromeTypes(callback){
    axios.get('/api/dmz/dict/syndrome/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getAgeGroups(callback){
    axios.get('/api/dmz/dict/agegroups').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getSexes(callback){
    (callback & callback([{name:'MALE', value:'男'}, {name:'FEMALE', value:'女'}]));
    /*axios.get('/api/dmz/dict/sexes').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });*/
}

function getSymptomTypes(callback){
    axios.get('/api/dmz/dict/symptom/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getPositions(callback){
    axios.get('/api/dmz/dict/positions').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getDiseaseTypes(callback){
    axios.get('/api/dmz/dict/disease/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getDiseaseGroups(callback){
    axios.get('/api/dmz/dict/disease/groups').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getDrugTypes(callback){
    axios.get('/api/dmz/dict/drug/types').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}

function getDrugForms(callback){
    axios.get('/api/dmz/dict/drug/forms').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}


function getStockTypes(callback){
  axios.get('/api/dmz/dict/stock/types?type=').then(function (res) {
    if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}

function getStockInTypes(callback){
    axios.get('/api/dmz/dict/stock/types?type=IN').then(function (res) {
      if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
        callback & callback(res.biz);
      }
    }, function (res) {
    });
}

function getStockOutTypes(callback){
  axios.get('/api/dmz/dict/stock/types?type=OUT').then(function (res) {
    if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}

function getInvoiceTypes(callback){
  axios.get('/api/dmz/dict/invoices').then(function (res) {
    if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}

function getOrganConfig(organId, code, callback){
  axios.get('/api/clinic/organ/' + organId + '/config/'+code).then(function (res) {
    if (res.msg.flag == 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}


function getSystemConfig(code, callback){
  axios.get('/api/clinic/system/config/'+code).then(function (res) {
    if (res.msg.flag == 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}

function getSuppliers(keyword, length, callback){
  axios.get('/api/clinic/suppliers',{params:{keyword:keyword, length:length||10}}).then(function (res) {
    if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
      callback & callback(res.biz);
    }
  }, function (res) {
  });
}

function getDeliveryModels(callback){
	axios.get('/api/dmz/dict/delivery/models',{}).then(function (res) {
		if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
			callback & callback(res.biz);
		}
	}, function (res) {
	});
}

function getExpressUnits(callback){
	axios.get('/api/dmz/dict/express/units',{}).then(function (res) {
		if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
			callback & callback(res.biz);
		}
	}, function (res) {
	});
}

function getApplyOrganizations(callback){
    axios.get('/api/clinic/applyorgans').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            callback & callback(res.biz);
        }
    }, function (res) {
    });
}
